import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import AppState from '@webapp/store/state';
import { Translate } from 'react-localize-redux';

import { Subdomain } from '@services/subdomains/types/subdomain';
import { artistSiteUrl } from '@webapp/store/artist/selectors';
import { QuerySubdomain } from '@webapp/store/subdomains/action-creators';
import { UpdateSubdomain } from '@webapp/store/subdomains/action-creators';
import {
  QUERY_SUBDOMAIN_ERROR,
  UPDATE_SUBDOMAIN_ERROR,
  QUERY_SUBDOMAIN,
  UPDATE_SUBDOMAIN,
} from '@webapp/store/subdomains/actions';
import { getMainDomain } from '@webapp/utils/get-artist-site-url';
import CustomUrlEditor from '@components/form/custom-url-editor';

interface CustomUrlInputCtrlProps {
  className?: string;
  enableEditing?: boolean;
  defaultSubdomain: string;
  subdomain?: Subdomain;
  isLoading: boolean;
  disabled: boolean;
  isMobile: boolean;
  domainExists: boolean;
  error?: string;
  siteUrl: string;
  query: (name: string) => QuerySubdomain;
  updateDomain: (subdomain: string) => UpdateSubdomain;
  isGrey?: boolean;
}

const mapStateToProps = (state: AppState) => {
  const subdomain = state.subdomain.currentSubdomain;

  return {
    isLoading: !!(
      state.ui.loading[QUERY_SUBDOMAIN] || state.ui.loading[UPDATE_SUBDOMAIN]
    ),
    isMobile: state.ui.mobile,
    disabled: false, // subdomain?.status === 'CREATING',
    domainExists:
      !!state.subdomain.query &&
      state.subdomain.query.subdomain !== subdomain?.subdomain,
    error:
      state.ui.errors[UPDATE_SUBDOMAIN_ERROR] ||
      state.ui.errors[QUERY_SUBDOMAIN_ERROR],
    defaultSubdomain: state.artist.active?.shortId || '',
    siteUrl: artistSiteUrl(state),
    subdomain,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  query: (name: string) => dispatch(new QuerySubdomain(name)),
  updateDomain: (subdomain: string) => dispatch(new UpdateSubdomain(subdomain)),
});

export const CustomUrlInputCtrl: React.FC<CustomUrlInputCtrlProps> = (
  props
) => {
  const [error, setError] = React.useState<React.ReactNode | undefined>();

  const isValid = (value: string) => {
    if (/^[a-z0-9][a-z0-9-_]*$/.test(value)) {
      setError(undefined);
      return true;
    }

    setError(<Translate id="SUBDOMAIN.INVALID" />);
    return false;
  };

  const handleEdit = (value: string) => {
    if (!isValid(value)) {
      return;
    }

    if (value) {
      props.query(value);
    }
  };

  const changeSubDomain = (value: string) => {
    if (value && !props.disabled && !props.isLoading) {
      props.updateDomain(value);
    }
  };

  const taken =
    props.domainExists || props.error === 'SUBDOMAINS.UNAVAILABLE' ? (
      <Translate id="SUBDOMAIN.TAKEN" />
    ) : undefined;

  return (
    <div
      className={props.className}
      onClick={() => document.execCommand('copy')}
    >
      <CustomUrlEditor
        isGrey={props.isGrey}
        value={props.subdomain?.subdomain || props.defaultSubdomain}
        fixed={`.${getMainDomain()}`}
        fullValue={props.siteUrl}
        enableEditing={!!props.enableEditing}
        formatter={(value) => value.toLowerCase().split('.')[0].trim()}
        handleEdit={handleEdit}
        handleChange={changeSubDomain}
        error={error || taken}
        isLoading={props.isLoading}
        isMobile={props.isMobile}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomUrlInputCtrl);
